// Marketing · Automatizaciones (montado en /marketing/automatizaciones/*): lista, editor y detalle.
import type { JSX } from "react";
import { Route, Routes } from "react-router-dom";
import { FlowList } from "./flows/FlowList.tsx";
import { FlowEditor } from "./flows/FlowEditor.tsx";
import { FlowDetail } from "./flows/FlowDetail.tsx";

export function MktFlows(): JSX.Element {
  return (
    <Routes>
      <Route index element={<FlowList />} />
      <Route path="nuevo" element={<FlowEditor />} />
      <Route path=":id/editar" element={<FlowEditor />} />
      <Route path=":id" element={<FlowDetail />} />
    </Routes>
  );
}
